var exports = {
  "Nr": "AccountSecurityCard.module__card___U0RkV2",
  "nL": "AccountSecurityCard.module__headerless___U0RkV2",
  "Ge": "AccountSecurityCard.module__rows___U0RkV2",
  "wx": "AccountSecurityCard.module__header___U0RkV2",
  "TK": "AccountSecurityCard.module__headerText___U0RkV2",
  "$": "AccountSecurityCard.module__titleRow___U0RkV2",
  "DD": "AccountSecurityCard.module__title___U0RkV2",
  "h_": "AccountSecurityCard.module__description___U0RkV2",
  "QE": "AccountSecurityCard.module__headerAction___U0RkV2",
  "nM": "AccountSecurityCard.module__row___U0RkV2",
  "qg": "AccountSecurityCard.module__rowText___U0RkV2",
  "xZ": "AccountSecurityCard.module__rowLabel___U0RkV2",
  "Z$": "AccountSecurityCard.module__rowDescription___U0RkV2",
  "TF": "AccountSecurityCard.module__rowWarning___U0RkV2",
  "cm": "AccountSecurityCard.module__rowActions___U0RkV2",
  "OL": "AccountSecurityCard.module__emptyRow___U0RkV2",
  "xH": "AccountSecurityCard.module__switchRow___U0RkV2",
};

module.exports = exports;
